<template>
  <div class="relative">
    <dok-input
      size="lg"
      :d-placeholder="
        !dPlaceholder ? 'Rechercher un médicament ...' : dPlaceholder
      "
      d-type="text"
      :label="dLabel"
      :d-model.sync="term"
    >
      <template v-slot:leftIcon>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
            stroke="#AAAAAA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21 20.9999L16.65 16.6499"
            stroke="#AAAAAA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </dok-input>
    <div
      class="bg-greyx rounded-b max-h-200 overflow-y-scroll flex flex-col gap-y-1 absolute w-full scroll-items z-1"
      v-if="listShow"
    >
      <div class="flex justify-end w-full pt-2">
        <span
          class="cursor-pointer"
          @click="
            () => {
              listShow = false;
            }
          "
        >
          <img src="/svg/consultation/info/x.svg" />
        </span>
      </div>
      <div
        v-if="!data.length"
        class="text-center text-base text-nblue font-semibold py-3"
      >
        <i class="fas fa-exclamation-triangle"></i> Il n'y a aucun résultat,
        veuillez réessayer
      </div>
      <ul v-if="data.length">
        <li
          v-for="(list, i) in data"
          :key="i"
          class="cursor-pointer py-2 px-2 font-EffraR text-base hover:bg-dokBlue-lighter"
          :class="
            data.length - 1 != i
              ? 'border-0 border-b border-solid border-gray-300'
              : ''
          "
          @click="setItemParent(list)"
        >
          {{ list.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus";
import algoliasearch from "algoliasearch/lite";

export default {
  props: {
    setItemParent: Function,
    classes: String,
    dPlaceholder: String,
    dLabel: String
  },
  data() {
    return {
      searchClient: algoliasearch(
        "2BJUOM1BDB",
        "7906f008c0346b78f39d051fa293387f"
      ),
      data: [],
      term: null,
      listShow: false,
      stopWatch: false
    };
  },
  watch: {
    term: function(newValue, oldValue) {
      this.$emit("input", newValue);
      if (this.stopWatch) return;
      if (newValue && newValue.length > 1) {
        this.searchMedicament(newValue);
      } else {
        this.listShow = false;
      }
    }
  },
  methods: {
    searchMedicament: async function(val) {
      let index_search = this.searchClient.initIndex("dokma_dev_drugs");
      index_search.search(val).then(({ hits }) => {
        if (hits.length) {
          this.data = hits;
        }

        this.listShow = true;
      });
    }
  },
  mounted() {
    let _this = this;
    EventBus.$on("closeMedicamentInput", function(data) {
      _this.stopWatch = true;
      _this.term = data.name;
      _this.listShow = false;
      setTimeout(() => {
        _this.stopWatch = false;
      }, 500);
    });
    EventBus.$on("emptyMedicamentInput", () => {
      _this.term = null;
    });
    EventBus.$on("setNameMedicament", medicament => {
      _this.stopWatch = true;
      _this.term = medicament;
      setTimeout(() => {
        _this.stopWatch = false;
      }, 500);
      _this.$forceUpdate();
    });
  }
};
</script>
